<template>
    <el-dialog
        :visible.sync="dialogCreateShipment.dialogShow"
        width="80%"
        :close-on-press-escape="false"
        :close-on-click-modal="false"
        custom-class="loadingCreateShipmentMobile"
        append-to-body
        >
        <el-row>
             <div v-if="showResult">
                <h1 class="text-md-center" >ยืนยันการ Create Shipment</h1>
                <h1 class="text-md-center">รายการ</h1>
                <hr>
                <div v-for="(item,index) in dialogCreateShipment.itemList" :key="index" >
                    <h1 class="text-md-center">ร้าน : {{item.shopName}} จำนวนจำนวนออเดอร์ : {{item.orderNumbers.length}}</h1>
                </div>
            </div>
            <div v-else>
                <h1 class="text-md-center" >Result Create Shipment</h1>
                <h1 class="text-md-center">รายการร้าน</h1>
                <hr>
                <div v-for="(item,index) in resultCreateShipment" :key="index" >
                    <h1 class="text-md-center">ร้าน : {{item.shopName}} จำนวนจำนวนออเดอร์ : {{item.result.length}}</h1>
                    <el-table
                    :data="item.result"
                    :header-cell-style="{'background-color': 'black', 'color': 'white'}"
                    border
                    style="width: 100%">
                        <el-table-column
                        prop="orderNumber"
                        label="orderNumber"
                        width="120">
                        </el-table-column>
                        <el-table-column
                        prop="trackingNumber"
                        label="trackingNumber"
                        width="130">
                        </el-table-column>
                        <el-table-column
                        prop="courierProviderName"
                        label="Courier"
                        width="100"
                        >
                        </el-table-column>
                        <el-table-column
                        prop="errorCode"
                        label="errorCode"
                        width="80">
                        </el-table-column>
                        <el-table-column
                        prop="errorMessage"
                        label="errorMessage">
                        </el-table-column>
                    </el-table>
                </div>
            </div>
             <div class="text-md-center" style="margin-top:15px">
                <el-button @click="dialogCreateShipment.dialogShow = false">ปิด</el-button>
                <el-button type="primary" @click="createShipment" v-if="showResult">ยืนยัน</el-button>
            </div>
        </el-row>

    </el-dialog>
</template>

<script>

import fgApi from '@/services/fillgoods'

export default {
    name: 'dialogCreateShipmentMobile',
    props: {
        dialogCreateShipment: {
            type: Object
        }
    },
    data () {
        return {
            showResult: true,
            resultCreateShipment: []
        }
    },
    watch: {
        'dialogCreateShipment.dialogShow' (val) {
            if (val) {
                // open dialog
            } else {
                // close dialog
                this.showResult = true
                this.resultCreateShipment = []
            }
        }
    },
    methods: {
        async createShipment () {
            this.$loading()
            let result = []
            console.log(this.dialogCreateShipment.itemList)
            for await (const item of this.dialogCreateShipment.itemList) {
                let resultShop = []
                for await (const itemGroup of Object.values(item.groupStatus)) {
                    // console.log(itemGroup)
                    // let orderArray = itemGroup.map(s => s.orderNumber)
                    let orderArray = []
                    let orderFailCovid = []
                    for await (const data of itemGroup) {
                        if (data.courierId !== 10) {
                            const param = {
                                courierId: data.courierId,
                                subDistrict: data.shippingSubDistrict,
                                district: data.shippingDistrict,
                                province: data.shippingProvince
                            }
                            let res = await fgApi.order.checkCovidAddress(param)
                            // console.log(res)
                            if (!res.success) {
                                if (res.data.courierId === 1) {
                                    orderFailCovid.push({ ...data,
                                        res: res.data,
                                        mockError: {
                                            orderNumber: data.orderNumber,
                                            errorCode: 'COVID-19',
                                            errorMessage: 'เนื่องจากมีประกาศฉุกเฉินห้ามประชาชนเข้าพื้นที่เสี่ยง ไม่สามารถเข้ารับ และ ส่งพัสดุในพื้นที่ดังกล่าวได้',
                                            trackingNumber: '',
                                            courierProviderName: 'SCG'
                                        }
                                    })
                                } else if (res.data.courierId === 4 && res.data.type === 3) {
                                    orderFailCovid.push({ ...data,
                                        res: res.data,
                                        mockError: {
                                            orderNumber: data.orderNumber,
                                            errorCode: 'COVID-19',
                                            errorMessage: 'เนื่องจากมีประกาศฉุกเฉินห้ามประชาชนเข้าพื้นที่เสี่ยง ไม่สามารถเข้ารับ และ ส่งพัสดุในพื้นที่ดังกล่าวได้',
                                            trackingNumber: '',
                                            courierProviderName: 'FLASH'
                                        }
                                    })
                                } else {
                                    orderArray.push(data.orderNumber)
                                }
                            } else {
                                orderArray.push(data.orderNumber)
                            }
                        }
                    }
                    // console.log(orderArray, orderFailCovid)
                    let param = {
                        orderNumbers: orderArray,
                        shopId: item.shopId,
                        status: itemGroup[0].status,
                        adminEmail: this.$store.get('user/objUser').email
                    }
                    console.log(param)
                    try {
                        let res = await fgApi.order.createShipment(param)
                        const resultFilterJnTFail = res.result.filter(e => {
                            return e.courierProviderName === 'J&T' && e.errorCode === 'S10'
                        })
                        console.log('result filter', resultFilterJnTFail)
                        let newResult = []
                        if (resultFilterJnTFail.length > 0) {
                            const orderNumber = resultFilterJnTFail.map(e => e.orderNumber)
                            console.log('map order Number', orderNumber)
                            let paramUpdate = {
                                orderNumbers: orderNumber,
                                shopId: item.shopId,
                                status: itemGroup[0].status,
                                adminEmail: this.$store.get('user/objUser').email
                            }
                            console.log('update', paramUpdate)

                            let resUpdate = await fgApi.order.updateShipment(paramUpdate)
                            newResult = res.result.filter(e => {
                                const isOrder = orderNumber.includes(e.orderNumber)
                                if (!isOrder) {
                                    return e
                                }
                            })
                            newResult = [...newResult, ...resUpdate.result]
                            console.log(newResult, res.result)
                        } else {
                            newResult = res.result
                        }
                        if (res.success) {
                            resultShop = resultShop.concat(newResult)
                            if (orderFailCovid.length > 0) {
                                orderFailCovid.forEach(e => {
                                    resultShop = resultShop.concat(e.mockError)
                                })
                            }
                            console.log(resultShop)
                            try {
                                if (param.orderNumbers.length > 0) {
                                    await fgApi.order.updateDeliveryCost(param)
                                }
                            } catch (error) {
                                console.log(error)
                            }
                        }
                    } catch (error) {
                        console.log(error)
                    }
                }
                result.push({
                    shopName: item.shopName,
                    result: resultShop
                })
            }
            console.log(result)
            this.showResult = false
            this.resultCreateShipment = result
            this.$emit('refreshAllOrder')
            this.$loading().close()
        }
    }
}
</script>

<style lang="scss">
.loadingCreateShipmentMobile{
    font-family: 'Prompt', sans-serif !important;
}
</style>
